import _ from 'lodash';

import { getDatabase } from 'scripts/infrastructure/backends/fake_backend/database';
import getNormalizedEmailAddress from 'scripts/lib/get_normalized_email_address';
import { normalizePhoneNumber } from 'models/phone_number';
import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

const DEFAULT_QUERY_KEYS = [
  'address',
  'customAttributes',
  'emails',
  'name',
  'phones',
  'phone',
  'email',
  'externalCustomerId',
  'externalCustomerIds',
];

export default class ExternalCustomerLookupService {
  constructor(getDb = getDatabase) {
    this.getDatabase = getDb;
  }

  _getIntegrations(orgId) {
    return this.getDatabase(orgId).integrations;
  }

  fetch(orgId, payload) {
    return ExternalCustomerLookupService.find(this.getDatabase(orgId), orgId, payload).results;
  }

  static find(datastore, orgId, payload) {
    const query = payload.query;
    let externalProfiles =
      _.filter(datastore.externalProfiles, externalProfile => {
        const defaultQueryResult =
          (!query.name || (query.name && externalProfile.name === query.name)) &&
          (!query.address || (query.address && externalProfile.address === query.address)) &&
          (!query.emails ||
            !query.emails.length ||
            (query.emails &&
              externalProfile.emails &&
              _.some(query.emails, queryEmail =>
                _.find(
                  externalProfile.emails,
                  externalEmail =>
                    getNormalizedEmailAddress(externalEmail.original) === getNormalizedEmailAddress(queryEmail)
                )
              ))) &&
          (!query.email ||
            (query.email &&
              externalProfile.emails &&
              _.find(
                externalProfile.emails,
                externalEmail => normalizePhoneNumber(externalEmail.original) === normalizePhoneNumber(query.email)
              )) ||
            (query.name && externalProfile.name === query.name)) &&
          (!query.phone ||
            (query.phone &&
              externalProfile.phones &&
              _.find(
                externalProfile.phones,
                externalPhone => normalizePhoneNumber(externalPhone.original) === normalizePhoneNumber(query.phone)
              ))) &&
          (!query.phones ||
            !query.phones.length ||
            (query.phones &&
              externalProfile.phones &&
              _.some(query.phones, queryPhone =>
                _.find(
                  externalProfile.phones,
                  externalPhone => normalizePhoneNumber(externalPhone.original) === normalizePhoneNumber(queryPhone)
                )
              )));

        const customKeys = _.keys(_.omit(query, DEFAULT_QUERY_KEYS));
        const customQueryResult =
          !customKeys.length ||
          (customKeys.length &&
            _.every(
              _.map(customKeys, customKey => {
                return (
                  !query[customKey] || query[customKey] === _.get(externalProfile, `customAttributes.${customKey}`)
                );
              })
            ));
        return defaultQueryResult && customQueryResult;
      }) || [];

    // The "BASIC" result does not include transactions
    if (payload.lookupLevel === 'BASIC') {
      externalProfiles = externalProfiles.map(profile => {
        return _.omit(profile, ['transactions']);
      });
    }

    return {
      results: externalProfiles,
    };
  }

  findByIntegrationId(query, orgId) {
    const allResults = ExternalCustomerLookupService.find(this.getDatabase(orgId), orgId, query);

    return _.groupBy(allResults.results, result => result.integrationId);
  }

  findV2(payload, callback, path, { orgId }) {
    callback(null, { status: 200, statusText: statusText(200), response: this.findByIntegrationId(payload, orgId) });
  }

  getLookupStatus(payload, callback, path, { orgId }) {
    callback(null, { status: 200, statusText: statusText(200), response: this._getIntegrations(orgId) });
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v2/orgs/:orgId/external-customer-lookup': {
          POST: this.findV2,
        },
        '/api/v2/orgs/:orgId/external-customer-lookup-status': {
          GET: this.getLookupStatus,
        },
      },
      this
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend/external_customer_lookup_service.js